import { CompoApp } from '../services/CompoApp';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { HeaderClientService } from '../services/client/header-service/header-client.service';
import { HeaderBreadCrumbClientService } from '../services/client/header-service/header-bread-crumb-client.service';
import { UserTipsClientService } from '../services/client/user-service/user-tips-client.service';
import { UserPrivilegeRequestService } from '../services/user-privilege-request.service';
import { UserPrivilegeSetApiService } from '../services/user-privilege-set-api.service';
import { UserAreaService } from '../services/user-area.service';
import { ClassTreeClientService } from '../services/client/class-service/class-tree-client.service';
import { HeaderOrgLocationService } from '../services/client/header-service/header-org-location.service';
import { NavigationClientService } from '../services/client/navigation-service/navigation-client.service';
import { ModuleOrgClassSelectionRequestService } from '../services/request/module-org-class-selection-request.service';
import { RoutesNavigationClientService } from '../services/client/navigation-service/routes-navigation-client.service';
import { CommunityRequestService } from '../services/request/community-request.service';
import { FavoriteRequestService } from '../services/request/favorite-request.service';
import { ObjectRequestService } from '../services/request/object-request.service';
import { Dialog2Service } from '../services/dialog2.service';
import { AppDataClientService } from '../services/client/app-service/app-data-client.service';
import { BaseApiService } from '../services/api/base-api.service';
import { FilterOptionFetchService } from '../services/client/filter-option/filter-option-fetch.service';
import {
  FilterOptionsSubPageClientService
} from '../content/pages-new-design/admin-area-page/filter-options-sub-page/filter-options-sub-page-client.service';
import { UserRightAssignmentRequestService } from '../services/request/user-right-assignment-request.service';
import { NgxsModule, Store } from '@ngxs/store';
import { environment } from '../../environments/environment';
import { UserRightsXsState } from '../states/user-rights/user-rights-xs.state';
import { CommunityRightsXsState } from '../states/community-rights/community-rights-xs.state';
import { ObjectActionXsState } from '../states/object/action/object-action-xs.state';
import {
  OrganizationLocationTreeXsState
} from '../states/organization-location-tree/organization-location-tree-xs.state';
import {
  OrgLocationClassObjectSelectDialogXsState
} from '../states/org-location-object-select-dialog/org-location-class-object-select-dialog-xs.state';
import { ClassFieldsRequestService } from '../services/request/class-fields-request.service';
import { OaSelectJobroutineXsState } from '../states/object/action/jobroutine/oa-select-jobroutine-xs.state';
import { OaJobroutineForObjectsXsState } from '../states/object/action/jobroutine/oa-jobroutine-for-objects-xs.state';
import { WorkGroupRequestService } from '../services/request/work-group-request.service';
import { UserRequestService } from '../services/user-request.service';
import { UserDetailXsState } from '../states/user/user-detail-xs.state';
import { UserRightsFunctionDetailXsState } from '../states/user-rights-function/user-rights-function-detail-xs.state';
import { UserRightsRoleDetailXsState } from '../states/user-rights-role/user-rights-role-detail-xs.state';
import { OrganizationRequestService } from '../services/request/organization-request.service';
import { ContractDetailXsState } from '../states/contract/contract-detail-xs.state';
import { MultiObjectRequestService } from '../services/request/multi-object-request.service';
import { OrganizationDetailXsState } from '../states/organization/organization-detail-xs.state';
import { MultiObjectRentalRequestService } from '../services/request/multi-object-rental-request.service';
import { ImportRequestService } from '../services/request/import-request.service';
import { ObjectHistoryRequestService } from '../services/request/object-history-request.service';
import { SmartFilterXsState } from '../states/smart-filter/smart-filter-xs.state';
import { ObjectImportDetailXsState } from '../states/object-import/object-import-detail-xs.state';
import { CostTypeRequestService } from '../services/request/cost-type-request.service';
import { DocumentTypeRequestService } from '../services/request/document-type-request.service';
import { MessageTypeRequestService } from '../services/request/message-type-request.service';
import { JobTypeRequestService } from '../services/request/job-type-request.service';
import {
  JobOverallAssessmentTypeRequestService
} from '../services/request/job-overall-assessment-type-request.service';
import {
  WorkGroupRightAssignmentRequestService
} from '../services/request/work-group-right-assignment-request.service';
import { UserAreaEditorXsState } from '../states/user-area-editor/user-area-editor-xs.state';
import { UserAreaDetailXsState } from '../states/user-area/user-area-detail-xs-state.service';
import { JobImportDetailXsState } from '../states/job-import/job-import-detail-xs.state';
import { UserSettingRequestService } from '../services/request/user-setting-request.service';
import { DashboardXsState } from '../states/dashboard/dashboard-xs.state';
import { ChecklistTemplateDetailXsState } from '../states/checklist-template/checklist-template-detail-xs.state';
import {
  ChecklistTemplateEntryManagerXsState
} from '../states/checklist-template-entry-manager/checklist-template-entry-manager-xs.state';
import { TriggerManagerXsState } from '../states/trigger/trigger-manager-xs.state';
import {
  ChecklistTemplateEntryReorderXsState
} from '../states/checklist-template-entry-reorder/checklist-template-entry-reorder-xs.state';
import { InvitationRequestService } from '../services/invitation-request.service';
import { ChecklistFillOutXsState } from '../states/checklist-fill-out/checklist-fill-out-xs.state';
import { JobFillOutXsState } from '../states/job-fill-out/job-fill-out-xs.state';
import {
  ChecklistTemplateVersionXsState
} from '../states/checklist-template-version/checklist-template-version-xs.state';
import { AsyncPipe, DatePipe } from '@angular/common';
import {
  ChecklistTemplateVersionReleasedClassesXsState
} from '../states/checklist-template-version-released-classes/checklist-template-version-released-classes-xs.state';
import {
  DocumentGroupTypeToEnumValuePipe
} from '../pipes/model/document_group_type/document-group-type-to-enum-value.pipe';
import { ChecklistRequestService } from '../services/request/checklist-request.service';
import {
  ChecklistTemplateEntryConditionXsState
} from '../states/checklist-template-entry-condition/checklist-template-entry-condition-xs.state';
import { ChecklistTemplateEntryRequestService } from '../services/request/checklist-template-entry-request.service';
import { FilesDetailXsState } from '../states/files-detail/files-detail-xs.state';
import {
  FilesDetailReleasedClassesXsState
} from '../states/files-detail-released-classes/files-detail-released-classes-xs.state';
import { ObjectClassActionXsState } from '../states/object-class/action/object-class-action-xs.state';
import { CompanyContactDialogXsState } from '../states/company-contact-dialog/company-contact-dialog-xs.state';
import { CompanyContactRequestService } from '../services/request/company-contact-request.service';
import { CountryService } from '../services/country.service';
import {
  CompanyContactInfoOverlayXsState
} from '../states/company-contact-info-overlay/company-contact-info-overlay-xs.state';
import {
  ChecklistTemplateEntryTableRowConversionXsState
} from '../states/checklist-template-entry-table-row-conversion/checklist-template-entry-table-row-conversion-xs.state';
import { InvoiceDialogXsState } from '../states/invoice-dialog/invoice-dialog-xs.state';
import {
  ChecklistTemplateEntryDuplicationXsState
} from '../states/checklist-template-entry-duplication/checklist-template-entry-duplication-xs.state';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import {
  ChecklistTemplateOverallAssessmentXsState
} from '../states/checklist-template-overall-assessment/checklist-template-overall-assessment-xs.state';
import {
  AssessmentWithSeverityActionRequestService
} from '../services/request/assessment-with-severity-action-request.service';
import { ModuleAttributeGroupRequestService } from '../services/request/module-attribute-group-request.service';
import { ServiceProviderRequestService } from '../services/request/service-provider-request.service';
import { ServiceProviderDialogXsState } from '../states/service-provider-dialog/service-provider-dialog-xs.state';
import { ServiceProviderDetailXsState } from '../states/service-provider-detail/service-provider-detail-xs.state';
import {
  AssessmentWithSeverityActionDialogXsState
} from '../states/assessment-with-severity-action-dialog/assessment-with-severity-action-dialog-xs.state';
import { LocalizedDatePipePipe } from '../pipes/localizedDatePipe.pipe';
import {
  ChecklistTemplateSettingsQueriesXsState
} from '../states/checklist-template-settings/checklist-template-settings-queries/checklist-template-settings-queries-xs.state';
import {
  ChecklistTemplateEntryInputQuickSettingsDialogXsState
} from '../states/checklist-template-entry-input-quick-settings-dialog/checklist-template-entry-input-quick-settings-dialog-xs.state';
import { SubObjectActionXsState } from '../states/sub-object/action/sub-object-action-xs.state';
import { RContractXsState } from '../states/user-rights/topic-based/contract/r-contract-xs.state';
import { ROrganizationXsState } from '../states/user-rights/topic-based/organization/r-organization-xs.state';
import { RUserRoleXsState } from '../states/user-rights/topic-based/user-role/r-user-role-xs.state';
import { RUserFunctionXsState } from '../states/user-rights/topic-based/user-function/r-user-function-xs.state';
import { UserRightsRoleRequestService } from '../services/request/user-rights-role-request.service';
import { UserRightsFunctionRequestService } from '../services/request/user-rights-function-request.service';
import { RLocationXsState } from '../states/user-rights/topic-based/location/r-location-xs.state';
import { RUserXsState } from '../states/user-rights/topic-based/user/r-user-xs.state';
import { RUserAreaXsState } from '../states/user-rights/topic-based/user-area/r-user-area-xs.state';
import { RWorkGroupXsState } from '../states/user-rights/topic-based/work-group/r-work-group-xs.state';
import { RModuleXsState } from '../states/user-rights/topic-based/module/r-module-xs.state';
import { UserSettingsWidgetService } from '../services/request/user-settings-widget.service';
import { IdentityRequestService } from '../services/request/identity-request.service';
import { RFileXsState } from '../states/user-rights/topic-based/file/r-file-xs.state';
import {
  RUserRightsAssignmentXsState
} from '../states/user-rights/topic-based/user-rights-assignment/r-user-rights-assignment-xs.state';
import {
  RWorkGroupRightsAssignmentXsState
} from '../states/user-rights/topic-based/work-group-rights-assignment/work-group-rights-assignment-xs.state';
import {
  RJobOverallAssessmentXsState
} from '../states/user-rights/topic-based/job-overall-assessment/r-job-overall-assessment-xs.state';
import { RProducerXsState } from '../states/user-rights/topic-based/producer/r-producer-xs.state';
import { RContactXsState } from '../states/user-rights/topic-based/contact/r-contact-xs.state';
import {
  RChecklistTemplateXsState
} from '../states/user-rights/topic-based/checklistTemplate/r-checklist-template-xs.state';
import { RJobCategoryXsState } from '../states/user-rights/topic-based/job-category/r-job-category-xs.state';
import {
  RMessageCategoryXsState
} from '../states/user-rights/topic-based/message-category/r-message-category-xs.state';
import { RFileTypeXsState } from '../states/user-rights/topic-based/file-type/r-file-type-xs.state';
import { RJobRoutineXsState } from '../states/user-rights/topic-based/job-routine/r-job-routine-xs.state';
import { RJobXsState } from '../states/user-rights/topic-based/job/r-job-xs.state';
import {
  ServiceProviderRightAssignmentRequestService
} from '../services/request/service-provider-right-assignment-request.service';
import {
  RServiceProviderRightsAssignmentXsState
} from '../states/user-rights/topic-based/service-provider-rights-assignment/service-provider-rights-assignment-xs.state';
import {
  RServiceProviderXsState
} from '../states/user-rights/topic-based/service-provider/r-service-provider-xs.state';
import { RObjectXsState } from '../states/user-rights/topic-based/object/r-object-xs.state';
import { RClassXsState } from '../states/user-rights/topic-based/class/r-class-xs.state';

import { RMessageXsState } from '../states/user-rights/topic-based/message/r-message-xs.state';
import { RCostTypeXsState } from '../states/user-rights/topic-based/cost-type/r-cost-type-xs.state';
import { ObjectImportWizardXsState } from '../states/object-import/object-import-wizard-xs.state';
import { RImportXsState } from '../states/user-rights/topic-based/import/r-import-xs.state';
import { RTuevXsState } from '../states/user-rights/topic-based/tuev/r-tuev-xs.state';
import { RChatXsState } from '../states/user-rights/topic-based/chat/r-chat-xs.state';
import { RFilterXsState } from '../states/user-rights/topic-based/filter/r-filter-xs.state';
import { RCommunityXsState } from '../states/user-rights/topic-based/community/r-community-xs.state';
import { RFavoriteXsState } from '../states/user-rights/topic-based/favorite/r-favorite-xs.state';
import { RAiFeatureXsState } from '../states/user-rights/topic-based/ai-feature/r-ai-feature-xs.state';
import { RAdministrationXsState } from '../states/user-rights/topic-based/administration/r-administration-xs.state';
import { RequirePrivilegeService } from '../services/require-privilege.service';
import { RSettingXsState } from '../states/user-rights/topic-based/setting/r-setting-xs.state';
import { RAccessRightsXsState } from '../states/user-rights/topic-based/acccess-rights/r-acccess-rights-xs.state';
import { RMaterialXsState } from '../states/user-rights/topic-based/material/r-material-xs.state';
import { RInvoiceXsState } from '../states/user-rights/topic-based/invoice/r-invoice-xs.state';
import { UserPasswordXsState } from '../states/user/user-password-xs.state';
import { OrganizationSettingRequestService } from '../services/request/organization-setting-request.service';
import { HistoryService } from '../services/history.service';
import { SseSingletonService } from '../services/sse/sse-singleton.service';
import {
  InProgressMessageClientService
} from '../services/client/in-progress-message/in-progress-message.client.service';
import {
  CreateProducerClientService
} from '../content/components/create-producer-design-b/create-producer-client.service';
import { HistoryPopupClientService } from '../content/components/history-popup/history-popup-client.service';
import { NotificationEventXsState } from '../states/notification-event/notification-event-xs.state';
import { ClientDetailXsState } from '../states/client/client-detail-xs.state';
import { ClientRequestService } from '../services/request/client-request.service';
import { ClientRightAssignmentRequestService } from '../services/request/client-right-assignment-request.service';
import { TodoXsState } from '../states/todo/todo-xs.state';
import { TodoRequestService } from '../services/request/todo-request.service';
import { UserSettingsXsState } from '../states/user-settings/user-settings-xs.state';
import {
  UserSettingsListColumnsXsState
} from '../states/user-settings-list-columns/user-settings-list-columns-xs.state';
import { CameraDialogClientService } from '../content/components/camera-dialog/camera-dialog-client.service';
import {
  SerialNumberScannerDialogClientService
} from '../content/components/serial-number-scanner-dialog/serial-number-scanner-dialog-client.service';
import { CustomFilterXsState } from '../states/custom-filter/custom-filter-xs-state.service';
import { JobFilterService } from '../services/filter/job-filter.service';
import { ObjectFilterService } from '../services/filter/object-filter.service';
import { CreateJobHelperService } from '../content/components/create-job-helper/create-job-helper.service';
import {
  CreateManualJobClientService
} from '../content/components/create-job-design-b/create-manual-job-client.service';
import {
  ServiceProviderTreeSourceService
} from '../content/globals/form-input/form-input-org-location-selector/service-provider-form-input-org-location-selector/service-provider-form-input-org-location-selector.service';
import {
  ObjectClassReplacementXsState
} from '../states/object-class/action/object-bulk-class-replacement-action-xs.state';
import { ReportXsState } from '../states/report/report-xs.state';
import { MessageFilterService } from '../services/filter/message-filter.service';
import { CustomizableClassTreeXsState } from '../states/customizable-class-tree/customizable-class-tree-xs.state';
import { OrganizationLocalService } from '../content/globals/organizations/organization-local.service';
import { RequirePrivilegeGuard } from '../services/guards/require-privilege.guard';
import { TuvImportGuard } from '../services/guards/tuv-import.guard';
import { MessageService } from 'primeng/api';
import { ServiceProviderModuleAdminRoleGuard } from '../services/guards/service-provider-module-admin-role.guard';
import {
  HeaderOrgLocationTreeDialogClientService
} from '../content/pages-new-design/home-page/header-dialog/object/change-place/header-org-location-tree-dialog-client.service';
import { WidgetService } from '../services/widget.service';
import { FormValuePipe } from '../content/components/input/form-input/form-value.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthGuardService } from '../services/authGuard.service';
import {
  EditJobRoutineClientService
} from '../content/components/edit-job-routine-design-b/edit-job-routine-client.service';
import { JobService } from '../services/job.service';
import { NotServiceTechnicianRoleGuard } from '../services/guards/not-service-technician-role.guard';
import {
  CreateObjectImportDialogClientService
} from '../content/components/create-object-import-dialog/create-object-import-dialog-client.service';
import { ClientModeRoleGuard } from '../services/guards/client-mode-role.guard';
import { DashesIfStringNullPipe } from '../pipes/dashes-if-string-null.pipe';
import { CvTranslatePipe } from '../pipes/cvTranslate.pipe';
import { TruncatePipe } from '../pipes/truncate.pipe';
import { TreeFilterPipe } from '../pipes/treeFilter.pipe';
import { AttributeDTOFilterPipe } from '../pipes/attributeDTO-filter.pipe';
import { AttributeFormFilterPipe } from '../pipes/attributeForm-filter.pipe';
import { ObjectToArrayPipe } from '../pipes/objectToArray.pipe';
import { AuthTokenPipe } from '../pipes/authToken.pipe';
import { AlphabeticalIndexPipe } from '../pipes/alphabeticalIndex.pipe';
import { LocalizedTimestampDatePipePipe } from '../pipes/localizedTimestampPipe.pipe';
import { TrustHtmlPipe } from '../pipes/trust-html.pipe';
import { CountryNamePipe } from '../pipes/country-name.pipe';
import { UserInitialsPipe } from '../pipes/userInitials.pipe';
import { JobStatusDesignBPipe } from '../pipes/job-status-design-b.pipe';
import { ReversePipe } from '../pipes/reverse-list.pipe';
import { ObjectAttributeFilterPipe } from '../pipes/object-attribute-filter.pipe';
import { TranslationCVPipe } from '../pipes/translation-cv.pipe';
import { GreetingPipe } from '../pipes/greeting.pipe';
import { WidgetDataTypeTranslationPipe } from '../pipes/widget-type-translation.pipe';
import { EmptyStringIfNullPipe } from '../pipes/empty-string-if-null.pipe';
import {
  ChecklistTemplateToChecklistTemplateDtoPipe
} from '../pipes/model/checklist-template/checklist-template-to-checklist-template-dto.pipe';
import { PrivilegeFilterPipe } from '../pipes/privilege-filter.pipe';
import { ContractGuard } from '../services/guards/contract.guard';
import { RWorkOrderXsState } from '../states/user-rights/topic-based/work-order/r-work-order-xs.state';
import { RComponentClassGroupXsState } from '../states/user-rights/topic-based/component-class-group/r-component-class-group-xs.state';
import { ComponentClassGroupDetailXsState } from '../states/component-class-group-detail/component-class-group-detail-xs.state';
import { RCheckinTemplateXsState } from '../states/user-rights/topic-based/checkin-template/r-checkin-template-xs.state';
import { CheckinTemplateDetailXsState } from '../states/checkin-template-detail/checkin-template-detail-xs.state';
import { ScrollDispatcher } from '@angular/cdk/overlay';


@NgModule({
  imports: [
    // NgxsModule.forRoot(SingletonModule.ngxsStores, {
    //   developmentMode: !environment.production
    // }),
    // NgxsStoragePluginModule.forRoot({
    //   keys: ['checklistTemplateEntryDuplication']
    // })
  ]
})
export class SingletonModule {
  static readonly ngxsStores = [
    ObjectClassReplacementXsState,
    ObjectActionXsState,
    OrganizationLocationTreeXsState,
    OrgLocationClassObjectSelectDialogXsState,
    UserRightsXsState,
    CommunityRightsXsState,
    OaSelectJobroutineXsState,
    OaJobroutineForObjectsXsState,
    UserDetailXsState,
    UserPasswordXsState,
    UserRightsFunctionDetailXsState,
    UserRightsRoleDetailXsState,
    ContractDetailXsState,
    DashboardXsState,
    OrganizationDetailXsState,
    SmartFilterXsState,
    UserAreaEditorXsState,
    UserAreaDetailXsState,
    ObjectImportDetailXsState,
    JobImportDetailXsState,
    CustomFilterXsState,
    ChecklistTemplateDetailXsState,
    ChecklistTemplateSettingsQueriesXsState,
    ChecklistTemplateEntryManagerXsState,
    ChecklistTemplateEntryDuplicationXsState,
    ChecklistTemplateEntryReorderXsState,
    ChecklistTemplateVersionXsState,
    ChecklistTemplateVersionReleasedClassesXsState,
    TriggerManagerXsState,
    ChecklistFillOutXsState,
    JobFillOutXsState,
    NotificationEventXsState,
    FilesDetailXsState,
    FilesDetailReleasedClassesXsState,
    ChecklistTemplateEntryConditionXsState,
    ChecklistTemplateEntryTableRowConversionXsState,
    ObjectClassActionXsState,
    CompanyContactDialogXsState,
    CompanyContactInfoOverlayXsState,
    InvoiceDialogXsState,
    ChecklistTemplateOverallAssessmentXsState,
    ServiceProviderDialogXsState,
    ServiceProviderDetailXsState,
    AssessmentWithSeverityActionDialogXsState,
    ChecklistTemplateEntryInputQuickSettingsDialogXsState,
    SubObjectActionXsState,
    ObjectImportWizardXsState,
    ClientDetailXsState,
    TodoXsState,
    UserSettingsXsState,
    UserSettingsListColumnsXsState,
    ReportXsState,
    CustomizableClassTreeXsState,

    //Rights privilege states
    RContractXsState,
    RUserAreaXsState,
    ROrganizationXsState,
    RUserRoleXsState,
    RUserFunctionXsState,
    RLocationXsState,
    RUserXsState,
    RMessageXsState,
    RWorkGroupXsState,
    RFileXsState,
    RUserRightsAssignmentXsState,
    RWorkGroupRightsAssignmentXsState,
    RServiceProviderRightsAssignmentXsState,
    RContactXsState,
    RJobCategoryXsState,
    RJobRoutineXsState,
    RChecklistTemplateXsState,
    RJobOverallAssessmentXsState,
    RProducerXsState,
    RJobXsState,
    RMessageCategoryXsState,
    RFileTypeXsState,
    RServiceProviderXsState,
    RObjectXsState,
    RModuleXsState,
    RCostTypeXsState,
    RClassXsState,
    RImportXsState,
    RAdministrationXsState,
    RTuevXsState,
    RChatXsState,
    RFilterXsState,
    RCommunityXsState,
    RFavoriteXsState,
    RAiFeatureXsState,
    RSettingXsState,
    RAccessRightsXsState,
    RMaterialXsState,
    RInvoiceXsState,
    RWorkOrderXsState,
    RComponentClassGroupXsState,
    ComponentClassGroupDetailXsState,
    RCheckinTemplateXsState,
    CheckinTemplateDetailXsState
  ];
  static readonly providers = [
    CompoApp,
    AsyncPipe,
    DatePipe,
    DocumentGroupTypeToEnumValuePipe,
    LocalizedDatePipePipe,
    AuthGuardService,
    NotServiceTechnicianRoleGuard,
    ClientModeRoleGuard,
    ContractGuard,

    ScrollDispatcher,

    CreateObjectImportDialogClientService,
    /* region needs to be refactored or (was migrated from CompoApp) */
    HistoryService,
    /* endregion */
    MessageService,
    OrganizationLocalService,
    RequirePrivilegeGuard,
    TuvImportGuard,
    ServiceProviderModuleAdminRoleGuard,

    HeaderOrgLocationTreeDialogClientService,
    WidgetService,
    FormValuePipe,
    TranslatePipe,

    /* region request-services */
    CommunityRequestService,
    FavoriteRequestService,
    WorkGroupRequestService,
    ObjectRequestService,
    UserSettingRequestService,
    UserSettingsWidgetService,
    UserRightAssignmentRequestService,
    WorkGroupRightAssignmentRequestService,
    ServiceProviderRightAssignmentRequestService,
    ClientRightAssignmentRequestService,
    MultiObjectRequestService,
    MultiObjectRentalRequestService,
    ClassFieldsRequestService,
    UserRequestService,
    OrganizationRequestService,
    ClientRequestService,
    ImportRequestService,
    ObjectHistoryRequestService,
    CostTypeRequestService,
    DocumentTypeRequestService,
    MessageTypeRequestService,
    JobTypeRequestService,
    JobOverallAssessmentTypeRequestService,
    InvitationRequestService,
    ChecklistRequestService,
    ChecklistTemplateEntryRequestService,
    CompanyContactRequestService,
    IdentityRequestService,
    AssessmentWithSeverityActionRequestService,
    ModuleAttributeGroupRequestService,
    ServiceProviderRequestService,
    UserRightsRoleRequestService,
    UserRightsFunctionRequestService,
    UserPrivilegeRequestService,
    OrganizationSettingRequestService,
    TodoRequestService,
    /** --- region --- RequestService --------------------------------------- */

    /** --- endregion --- RequestService ------------------------------------ */
    /* endregion request-services */

    /* region client-services */
    AppDataClientService,
    SseSingletonService,
    InProgressMessageClientService,
    BaseApiService,
    ModuleOrgClassSelectionRequestService,
    HeaderBreadCrumbClientService,
    HeaderOrgLocationService,
    UserTipsClientService,
    ClassTreeClientService,
    NavigationClientService,
    UserAreaService,
    UserPrivilegeSetApiService,
    RoutesNavigationClientService,
    FilterOptionFetchService,
    FilterOptionsSubPageClientService,
    CountryService,
    CreateProducerClientService,
    HistoryPopupClientService,
    CameraDialogClientService,
    SerialNumberScannerDialogClientService,
    JobFilterService,
    ObjectFilterService,
    CreateJobHelperService,
    CreateManualJobClientService,
    MessageFilterService,
    /* endregion client-services */

    /** region --- ROUTINE -------------------------------------------------- */
    EditJobRoutineClientService
    /** endregion --- ROUTINE ----------------------------------------------- */
  ];

  static forRoot(): ModuleWithProviders<SingletonModule> {
    return {
      ngModule: SingletonModule,
      providers: SingletonModule.providers
    };
  }

  private static requirePrivilegeService: RequirePrivilegeService;

  constructor(
    requirePrivilegeService: RequirePrivilegeService
  ) {
    SingletonModule.requirePrivilegeService = requirePrivilegeService;
  }

  public static getRequirePrivilegeService(): RequirePrivilegeService {
    return SingletonModule.requirePrivilegeService;
  }

}
